import { Box, Typography } from '@mui/material'
import { USER_PROFILE } from '@/config/userProfile'
import UserProfileInitialsAvatar from './UserProfileInitialsAvatar.jsx'
import styles from './accountMenu.module.scss'

function AccountMenuHeader({ accountFullName = USER_PROFILE.fullName, accountEmail = USER_PROFILE.email }) {
  return (
    <Box className={styles.accountPopoverHeader}>
      <UserProfileInitialsAvatar fullName={accountFullName} size="md" />
      <Box className={styles.accountPopoverText}>
        <Typography component="p" className={styles.accountPopoverName}>
          {accountFullName}
        </Typography>
        <Typography component="p" className={styles.accountPopoverEmail}>
          {accountEmail}
        </Typography>
      </Box>
    </Box>
  )
}

export default AccountMenuHeader
